// export const FIREBASE_CONFIG = {
//   apiKey: "AIzaSyD4PW-EkfMYF5t-Uq7vft3jreIGksPzCOs",
//   authDomain: "plugins-playground-7971a.firebaseapp.com",
//   projectId: "plugins-playground-7971a",
//   storageBucket: "plugins-playground-7971a.appspot.com",
//   messagingSenderId: "66818322724",
//   appId: "1:66818322724:web:c03ec9054d26ffb40e83b1",
//   measurementId: "G-H0VZ9TTFMY"
// };

// This is prod
export const FIREBASE_CONFIG = {
  apiKey: "AIzaSyAB2F5vJeTwaqYTRYOHTK3CIM5XgvK3NnA",
  authDomain: "fynestudio-apps.firebaseapp.com",
  databaseURL: "https://fynestudio-apps-default-rtdb.firebaseio.com",
  projectId: "fynestudio-apps",
  storageBucket: "fynestudio-apps.appspot.com",
  messagingSenderId: "820717950395",
  appId: "1:820717950395:web:4a91d84a46c10f07c4a09e",
  measurementId: "G-EL5EVFR246"
};